export default __webpack_public_path__ + "static/media/spiderDesk.991274c0.png";